module.exports = __webpack_public_path__ + "img/sign_in_to_continue.e4514751.png";